(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drink-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bundle-form]').forEach(function (form) {
    if (form.dataset.ready === 'true') return;
    form.dataset.ready = 'true';
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = form.querySelector('button[type="submit"]');
      var status = form.querySelector('[data-bundle-status]');
      var ids = Array.from(form.querySelectorAll('[data-bundle-select]')).map(function (select) { return select.value; });
      if (ids.some(function (id) { return !id; })) {
        status.textContent = 'Choose two products first.';
        return;
      }
      button.disabled = true;
      status.textContent = 'Adding your two-pack…';
      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart error');
          window.location.href = window.routes.cart_url;
        })
        .catch(function () {
          status.textContent = 'We could not add that pair. Please try again.';
          button.disabled = false;
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drink-hero-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dk-hs').forEach(function (root) {
    if (root.dataset.dkReady === 'true') return;
    root.dataset.dkReady = 'true';
    var slides = Array.from(root.querySelectorAll('.dk-hs__slide'));
    var dots = Array.from(root.querySelectorAll('[data-dkhs-dot]'));
    var pauseButton = root.querySelector('[data-dkhs-pause]');
    if (slides.length < 2) return;
    var index = 0;
    var timer;
    var interval = parseInt(root.dataset.interval, 10) || 6500;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var paused = reduceMotion;
    function show(next) {
      slides[index].classList.remove('is-on');
      slides[index].setAttribute('aria-hidden', 'true');
      dots[index].classList.remove('is-on');
      dots[index].setAttribute('aria-current', 'false');
      index = (next + slides.length) % slides.length;
      slides[index].classList.add('is-on');
      slides[index].setAttribute('aria-hidden', 'false');
      dots[index].classList.add('is-on');
      dots[index].setAttribute('aria-current', 'true');
    }
    function stop() {
      window.clearInterval(timer);
    }
    function play() {
      stop();
      if (!paused) timer = window.setInterval(function () { show(index + 1); }, interval);
    }
    function setPaused(value) {
      paused = value;
      pauseButton.setAttribute('aria-pressed', String(paused));
      pauseButton.textContent = paused ? pauseButton.dataset.playLabel : pauseButton.dataset.pauseLabel;
      play();
    }
    pauseButton.dataset.pauseLabel = pauseButton.textContent;
    pauseButton.dataset.playLabel = root.dataset.playLabel || 'Play';
    if (paused) setPaused(true);
    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () { show(dotIndex); play(); });
    });
    root.querySelector('[data-dkhs-prev]').addEventListener('click', function () { show(index - 1); play(); });
    root.querySelector('[data-dkhs-next]').addEventListener('click', function () { show(index + 1); play(); });
    pauseButton.addEventListener('click', function () { setPaused(!paused); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', play);
    play();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
